module.exports = {
    "Empty": `T\xfchjenda`
};


//# sourceMappingURL=et-EE.main.js.map
